export default __webpack_public_path__ + "static/media/t-dispatch-logo-white.8ff6d5b0.svg";